var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Erc20Bridger } from '@arbitrum/sdk';
/**
 * Fetches initiated token withdrawals from event logs in range of [fromBlock, toBlock].
 *
 * @param query Query params
 * @param query.address Account address
 * @param query.fromBlock Start at this block number (including)
 * @param query.toBlock Stop at this block number (including)
 * @param query.l2Network L2 network
 * @param query.l2Provider Provider for the L2 network
 * @param query.l2GatewayAddresses L2 gateway addresses to use
 */
export function fetchTokenWithdrawalsFromEventLogs({ address, fromBlock, toBlock, l2Network, l2Provider, l2GatewayAddresses }) {
    return __awaiter(this, void 0, void 0, function* () {
        const erc20Bridger = new Erc20Bridger(l2Network);
        return (yield Promise.all(l2GatewayAddresses.map(gatewayAddress => erc20Bridger.getL2WithdrawalEvents(l2Provider, gatewayAddress, { fromBlock, toBlock }, undefined, address)))).flat();
    });
}
